module.exports = __webpack_public_path__ + "static/media/supportTimelife.e6a6a51d.svg";